import LyShowTable from './src/index.vue'

LyShowTable.install = function (Vue) {
    Vue.component(LyShowTable.name, LyShowTable)
}

export default LyShowTable



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/show-table/index.js
// module id = null
// module chunks = 